"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useTabs_exports = {};
__export(useTabs_exports, {
  useTabs: () => useTabs
});
module.exports = __toCommonJS(useTabs_exports);
var import_react = require("react");
var import_getPathFromState_mods = require("../fork/getPathFromState-mods");
var import_matchers = require("../router/matchers");
var import_TabContext = require("../ui/TabContext");
var import_Navigator = require("../views/Navigator");
function useTabs() {
  var { state, descriptorsRef } = (0, import_Navigator.useNavigatorContext)();
  var triggerMap = (0, import_react.use)(import_TabContext.TabTriggerMapContext);
  var descriptors = descriptorsRef.current;
  return (0, import_react.useMemo)(function() {
    var screens = state.routes.map(function(route, index) {
      var _route_params;
      var descriptor = descriptors[route.key];
      var config = triggerMap[route.name];
      return {
        key: route.key,
        name: route.name,
        params: (_route_params = route.params) !== null && _route_params !== void 0 ? _route_params : {},
        href: config ? (0, import_matchers.stripGroupSegmentsFromPath)((0, import_getPathFromState_mods.appendBaseUrl)(config.href)) : "",
        isFocused: index === state.index,
        keepMounted: descriptor.options.keepMounted === true,
        options: descriptor.options,
        element: descriptor.render()
      };
    });
    return {
      screens,
      focused: screens[state.index]
    };
  }, [
    descriptors,
    state,
    triggerMap
  ]);
}
//# sourceMappingURL=useTabs.js.map
